import bem from '../../../utils/bem';
// eslint-disable-next-line no-unused-vars
import Credential from '../../Atoms/Credential';

const Credentials = (props) => {
  const { label, link, items } = props;

  return (
    <div className={bem('credentials', [], '', [])}>
      <div className={'credentials-head flex'}>
        <p className={'credentials-head__title h h6'}>
          {label || Drupal.t('CertainTeed Credentials')}
        </p>
        {link && (
          <a href={link.href} className={'credentials-head__link'}>
            {link.title}
          </a>
        )}
      </div>
      {items && (
        <ul className={'credentials__list flex'}>
          {items.map((item, index) => (
            <li key={index}>
              <Credential
                label={item.label}
                year={item.year}
                image={item.image}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Credentials;
